import { useHistory } from 'react-router-dom';
import { FunctionalLoader } from 'seagull';
import { Page } from 'seagull';
import { routes } from "../../constants";
import { useStore, useStoreActions } from "../../contexts";
import { useServiceTemplateApi } from "../../hooks/useServiceTemplateApi";
import ImportWizard from "../../components/ImportWizard/ImportWizard";
import { parseAndValidateServicesCsv } from "./parseAndValidateServicesCsv";
import { useSetDocumentTitle } from "../../hooks/useSetDocumentTitle";
import { useOnMount } from "../../hooks/useOnMount";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const csvTemplateUrl = 'https://storage.googleapis.com/anchor-statics/Anchor_Import_Services-2023-11-05.zip';
const title = 'Import Services';
export default function ImportServices() {
  const history = useHistory();
  const {
    data,
    loading,
    error
  } = useStore(state => state.serviceTemplates);
  const {
    fetchServiceTemplates,
    logBI
  } = useStoreActions();
  const serviceTemplateApi = useServiceTemplateApi();
  useSetDocumentTitle(title);
  useOnMount(() => {
    fetchServiceTemplates();
  });
  const gotoServiceLibrary = () => history.push(routes.serviceLibrary);
  if (error) throw error;
  return /*#__PURE__*/_jsxs(Page, {
    header: title,
    subheader: "Import your existing services in bulk in a few simple steps.",
    "data-testid": "import-services",
    loading: loading,
    onClickBack: gotoServiceLibrary,
    children: [/*#__PURE__*/_jsx(FunctionalLoader, {
      show: !data
    }), /*#__PURE__*/_jsx(ImportWizard, {
      entityName: "services",
      saveEntityName: "services",
      importBtnText: "Import services",
      csvTemplateUrl: csvTemplateUrl,
      testid: "import-services",
      parseAndValidateCsv: csvData => parseAndValidateServicesCsv(csvData, data.active),
      saveItem: serviceTemplateApi.create,
      onEvent: (name, payload) => {
        if (name === 'csvTemplateDownload') {
          logBI(12100);
        } else if (name === 'csvUploaded') {
          logBI(12101, {
            numErrors: payload.badCsv ? 1 : payload.errors.length,
            numRows: payload.items.length
          });
        } else if (name === 'redirectToItems') {
          gotoServiceLibrary();
        } else if (name === 'afterSaveFailure') {
          logBI(12102, {
            success: false
          });
        } else if (name === 'afterSaveSuccess') {
          logBI(12102, {
            success: true
          });
        }
      }
    })]
  });
}